module.exports = __webpack_public_path__ + "img/curaçao.c9985f20.svg";